// Feature toggles can be defined here using the format:
// <TOGGLE_NAME>: <flagKey>, e.g., FIRST_FEATURE_ENABLED: 'isMyFirstFeatureEnabled'
export const FeatureToggles = {
    EXAMPLE_FEATURE_TOGGLE: 'isExampleFeatureToggleEnabled',
    ENABLE_ADDITIONAL_VAT: 'isAdditionVatEnabled',
    SHIPPING_ADDRESS_REDESIGN: 'isShippingAddressRedesignEnabled',
    ENABLE_CARD_ORDER_HISTORY: 'isCardOrderHistoryEnabled',
} as const;
